<template>
 <content-loader
    viewBox="0 0 1170 240"
    :speed="1"
    primaryColor="#f3f3f3"
    secondaryColor="#cfcfcf"
  >
    <rect x="0" y="0" rx="0" ry="0" width="185" height="174" />
    <rect x="200" y="0" rx="0" ry="0" width="185" height="174" />
    <rect x="400" y="0" rx="0" ry="0" width="185" height="174" />
    <rect x="600" y="0" rx="0" ry="0" width="185" height="174" />
    <rect x="800" y="0" rx="0" ry="0" width="185" height="174" />
    <rect x="1000" y="0" rx="0" ry="0" width="185" height="174" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
export default {
  components: {
    ContentLoader,
  },
};
</script>